export enum PaymentExecutionStatus {
  Unknown,
  Na,
  Planned,
  Executed,
  HighRisk,
  ThresholdExceeded,
  Error,
}
